import axiosInstance from '../services/axiosConfig';
import type { CommunityMessageMedia } from '../services/communityService';

/**
 * Download a community message attachment via the backend proxy.
 *
 * We proxy through /api/communities/media/download instead of fetching the
 * Azure blob URL directly, because cross-origin fetch() to blob.core.windows.net
 * is blocked by CORS — the browser cannot set the required headers on that domain.
 * The backend downloads from Azure server-side and streams back with
 * Content-Disposition: attachment so the browser saves the file.
 */
export async function downloadMessageMedia(
  media: CommunityMessageMedia,
  fallbackName = 'download'
): Promise<void> {
  const filename = media.filename || fallbackName;

  const response = await axiosInstance.get('/api/communities/media/download', {
    params: {
      blob_name: media.blob_name,
      filename,
    },
    responseType: 'blob',
  });

  const objectUrl = URL.createObjectURL(response.data);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(objectUrl);
}
